import AulaService from '../../services/AulaService'
import router from '../../router'

const state = () => ({
    loadingAulas: false,
    aula: [],
    aulas: [],
    aulasSearch: [],
    aulasAssistidas: JSON.parse(localStorage.getItem('aulasAssistidas')) || [],
    nextAulas: [],
    keyword: ''
})
  
const mutations = {
    SET_AULA: (state, aula) => {
        state.aula = aula;
    },
    SET_AULAS: (state, aulas) => {
        state.aulas = aulas;
    },
    SET_AULAS_SEARCH: (state, aulas) => {
        state.aulasSearch = aulas;
    },
    SET_LOADING_AULAS: (state, payload) => {
        state.loadingAulas = payload
    },
    SET_AULAS_ASSISTIDAS: (state, payload) => {
        state.aulasAssistidas = payload
        localStorage.setItem('aulasAssistidas', JSON.stringify(payload));
    },
    SET_NEXT_AULAS: (state, aulas) => {
        state.nextAulas = aulas;
    }
}

const actions = {
    async fetchAula({commit}, id){
        try{
            commit('SET_LOADING_AULAS', true)
            const response = await AulaService.getOne(id);
            commit('SET_AULA', response.data)
            commit('SET_LOADING_AULAS', false)
        } catch (error) {
            commit('SET_LOADING_AULAS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
     async fetchAulas({commit}, params = {}){
        try{
            commit('SET_LOADING_AULAS', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' }, idCategory = null } = params;
            const response = await AulaService.get(keyword, pageNumber, pageSize,  order, idCategory);
            commit('SET_AULAS', response.data)
            commit('SET_LOADING_AULAS', false)
        } catch (error) {
            commit('SET_LOADING_AULAS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async registrarVisualizacao({commit, rootState, dispatch}) {
        try{
            const aula = rootState.aulas.aula
            if(!aula || aula == []){
                commit('SET_ALERT', {
                    heading: 'error',
                    message: "Aula não encontrada"
                });
            }
            const response = await AulaService.setAulaConcluida({AulaId: aula.id});

            if (response.data.heading === 'success') {
                commit('SET_ALERT', {
                    heading: 'success',
                    message: response.data.message
                });
            } else if (response.data.heading === 'info') {
                console.log("Aula concluída [ registrarVisualizacao ], error: " + response.data.message);
                return;
            } else {
                commit('SET_ALERT', {
                    heading: 'erro',
                    message: response.data.message
                });
                return;
            }

            dispatch('fetchAula', aula.id)
            dispatch('fetchSubject', aula.idDisciplina)
            dispatch('fetchProgressGeneral')
        }catch(error){
            commit('SET_ALERT', {
                heading: 'erro',
                message: error.response.data.message
            });
        }
    },
    async fetchVideosAssistidos({commit}){
        try {
            commit('SET_LOADING_AULAS', true);
            const response = await AulaService.getAllAulasAssistidas();
            commit('SET_AULAS_ASSISTIDAS', response.data);
      
            commit('SET_LOADING_AULAS', false);
        } catch (error) {
            commit('SET_LOADING_AULAS', false);
            commit('LOG_USER_OUT');
        }
    },
    async fetchSuggestionsAulas({commit, state}, params = {}) {
        try {
            const currentAula = await state.aula

            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' }, idCategory = null } = params;
            const response = await AulaService.get(keyword, pageNumber, pageSize,  order, idCategory);
            let sugestoes = response.data.itens || [];
            // Remove apenas a aula atual

            if (currentAula || currentAula.id) {   
                commit('SET_NEXT_AULAS', sugestoes.filter(aula => aula.id !== currentAula.id));
            } else{
                commit('SET_NEXT_AULAS', sugestoes);
            }
        } catch (error) {
            commit('SET_NEXT_AULAS', []);
        }
    },
}

const getters = {
    getAula: state => state.aula,
    getAulasAssistidas: state => state.aulasAssistidas,
    getAulasPesquisada: state => state.aulasSearch,
    getLoadingAula: state => state.loadingAulas,
    getNextAulas: state => state.nextAulas,
}

export default {
    state,
    getters,
    mutations,
    actions
};